import './src/styles/global.css';

export const onRouteUpdate = ({ location }: { location: Location }) => {
  if (typeof window === "undefined") {
    return;
  }

  if (location.search.includes("top=1")) {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    window.history.replaceState(null, "", location.pathname);
  }
};
